import { render, staticRenderFns } from "./UdSelectTwzip.vue?vue&type=template&id=c6849eea&scoped=true&"
import script from "./UdSelectTwzip.vue?vue&type=script&lang=js&"
export * from "./UdSelectTwzip.vue?vue&type=script&lang=js&"
import style0 from "./UdSelectTwzip.vue?vue&type=style&index=0&id=c6849eea&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6849eea",
  null
  
)

export default component.exports